// extracted by mini-css-extract-plugin
export var audioPlayer = "_sb-0";